import { render, staticRenderFns } from "./UserManagement.vue?vue&type=template&id=06fa2a24&"
import script from "./UserManagement.vue?vue&type=script&lang=ts&"
export * from "./UserManagement.vue?vue&type=script&lang=ts&"
import style0 from "./UserManagement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports